module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-featured.svg?8faa105df6e541a0f27bda4b7051162d";